import { render, staticRenderFns } from "./PlanoTrabalho.vue?vue&type=template&id=7c6c9fe8&"
import script from "./PlanoTrabalho.vue?vue&type=script&lang=js&"
export * from "./PlanoTrabalho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports